import CartItemsVehicle from './CartItemsVehicle';

export default CartItemsVehicle;
